// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"744":"8909e4c6","3527":"96c80bdd","4202":"8c48a8dd","4596":"23e7378f","6686":"23e7378f"}[chunkId] + ".chunk.css";
};